import { render, staticRenderFns } from "./MapIconPolyclinic.vue?vue&type=template&id=56164879&scoped=true&"
import script from "./MapIconPolyclinic.vue?vue&type=script&lang=js&"
export * from "./MapIconPolyclinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56164879",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56164879')) {
      api.createRecord('56164879', component.options)
    } else {
      api.reload('56164879', component.options)
    }
    module.hot.accept("./MapIconPolyclinic.vue?vue&type=template&id=56164879&scoped=true&", function () {
      api.rerender('56164879', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconPolyclinic.vue"
export default component.exports